import React from 'react'

import SelectField from './SelectField'

const addressTypesOptions = [
    { value: 'ACC', label: 'Acceso' },
    { value: 'ACE', label: 'Acera' },
    { value: 'ACQ', label: 'Acequia' },
    { value: 'AFU', label: 'Afuera' },
    { value: 'AGR', label: 'Agrupación' },
    { value: 'AL', label: 'Alameda' },
    { value: 'ALD', label: 'Aldea' },
    { value: 'AP', label: 'Apartado de Correos' },
    { value: 'APT', label: 'Apartamento' },
    { value: 'AR', label: 'AR' },
    { value: 'ARR', label: 'Arrabal' },
    { value: 'AUT', label: 'Autopista' },
    { value: 'AVD', label: 'Avenida' },
    { value: 'BCO', label: 'Barranco' },
    { value: 'BDA', label: 'Barriada' },
    { value: 'BL', label: 'Bloque' },
    { value: 'BO', label: 'Barrio' },
    { value: 'CAR', label: 'Carrer' },
    { value: 'CAS', label: 'Casa' },
    { value: 'CH', label: 'Chalet' },
    { value: 'CJN', label: 'Calleja' },
    { value: 'CJO', label: 'Callejón' },
    { value: 'CJT', label: 'Conjunto' },
    { value: 'CL', label: 'Calle' },
    { value: 'CM', label: 'Camino' },
    { value: 'CNO', label: 'Camino' },
    { value: 'COL', label: 'Colonia' },
    { value: 'COM', label: 'Complejo' },
    { value: 'CON', label: 'Camino' },
    { value: 'COO', label: 'Cooperativa' },
    { value: 'CRA', label: 'Carretera' },
    { value: 'CS', label: 'Caserío' },
    { value: 'CTA', label: 'Cuesta' },
    { value: 'CTJ', label: 'Cortijo' },
    { value: 'DIS', label: 'Diseminado' },
    { value: 'EDF', label: 'Edificio' },
    { value: 'ENT', label: 'Entrada' },
    { value: 'FCA', label: 'Finca' },
    { value: 'GPO', label: 'Grupo' },
    { value: 'GTA', label: 'Glorieta' },
    { value: 'GV', label: 'Gran Vía' },
    { value: 'LUG', label: 'Lugar' },
    { value: 'MAS', label: 'Masía' },
    { value: 'ME', label: 'Mercado' },
    { value: 'MLE', label: 'MLE' },
    { value: 'MU', label: 'Municipio' },
    { value: 'MZ', label: 'Manzana' },
    { value: 'NUC', label: 'Núcleo' },
    { value: 'PAT', label: 'Patio' },
    { value: 'PDA', label: 'Partida' },
    { value: 'PJE', label: 'Pasaje' },
    { value: 'POB', label: 'Poblado' },
    { value: 'POL', label: 'Polígono' },
    { value: 'PQE', label: 'Parque' },
    { value: 'PRL', label: 'Prolongación' },
    { value: 'PSO', label: 'Paseo' },
    { value: 'PZA', label: 'Plaza' },
    { value: 'PZL', label: 'Placeta' },
    { value: 'RAM', label: 'Rambla' },
    { value: 'RDA', label: 'Ronda' },
    { value: 'ROT', label: 'ROT' },
    { value: 'RSD', label: 'Residencia' },
    { value: 'RUA', label: 'Rua' },
    { value: 'SD', label: 'SD' },
    { value: 'SDA', label: 'Sendero' },
    { value: 'TRV', label: 'Travesía' },
    { value: 'URB', label: 'Urbanización' },
    { value: 'VIA', label: 'Vía' },
    { value: 'ZNA', label: 'Zona' },
]

const TypeOfStreetSelect = props => (
    <SelectField {...props}>
        {addressTypesOptions.map(item => (
            <option key={item.value} value={item.value}>
                {item.label}
            </option>
        ))}
    </SelectField>
)

export default TypeOfStreetSelect

